/** Domény emitentů pro hotlink faviconu z jejich webu. */
const ISIN_DOMAIN = {
  CZ0005112300: "cez.cz",
  DE000ENAG999: "eon.com",
  AT0000652011: "erstegroup.com",
  NL0000009165: "theheinekencompany.com",
  CZ0008019106: "kb.cz",
  HU0000153937: "molgroup.info",
  CZ0008040318: "moneta.cz",
  AT0000743059: "omv.com",
  CS0008418869: "pmi.com",
  NL0010391108: "photonenergy.com",
  CZ0009009874: "pilulka.cz",
  DE0007037129: "rwe.com",
  SE0000113250: "skanska.com",
  AT0000908504: "vig.com",
  AT0000730007: "andritz.com",
  AT0000969985: "ats.net",
  DE0005493092: "bvb.de",
  CZ0009008942: "coltczgroup.com",
  DE0005140008: "db.com",
  DE0005557508: "telekom.com",
  CZ0005123620: "e4u.cz",
  CZ0009009718: "eman.cz",
  CS0008419750: "energoaqua.cz",
  AT00000FACC2: "facc.com",
  CZ0009007027: "fillamentum.com",
  AT0000A21KS2: "immofinanz.com",
  CZ0009008819: "karoinvest.cz",
  PLPKO0000016: "kghm.com",
  CZ0009000121: "kofola.cz",
  FI0009000681: "nokia.com",
  HU0000061726: "otpbank.hu",
  PLPKN0000018: "orlen.pl",
  CZ0005131318: "prabos.cz",
  CZ0005135970: "primoco.aero",
  AT0000606306: "rbinternational.com",
  CS0008416251: "rms.cz",
  SK1120010287: "tmr.sk",
  CZ0005088559: "tomaas.cz",
  AT0000821103: "uniqa.at",
  AT0000746409: "verbund.com",
  AT0000937503: "voestalpine.com",
  DE0007664039: "volkswagenag.com",
  SE0000115446: "volvogroup.com",
  AT0000831706: "wienerberger.com",
  CZ0009011474: "footshop.cz",
  CZ0009009940: "sab.cz",
  NL0015073TS8: "csg.com",
  NL00150006R6: "ctp.eu",
  GB00BLGXWY71: "eurowag.com",
  CZ0009011920: "bezvavlasy.cz",
  GB00BVZK7T90: "unilever.com",
  GB00B10RZP78: "unilever.com",
  IT0005572778: "juventus.com",
  IT0000336518: "juventus.com",
  US6687711084: "gendigital.com",
  GB00BDD85M81: "avast.com"
};

export const shareMonogram = (name) => {
  const stop = /^(A\.?S\.?|SE|AG|SA|NV|PLC|INC|CORP\.?|GROUP|THE|AND|OF|ČR|CR|CS|PLUS|BANK\s*A)$/i;
  const words = String(name || "")
    .replace(/,/g, " ")
    .split(/\s+/)
    .map((w) => w.replace(/[.,]/g, ""))
    .filter((w) => w && !stop.test(w));
  if (!words.length) return "?";
  if (words.length === 1) {
    const letters = words[0].replace(/[^0-9A-Za-zÁÉÍÓÚÝČĎĚŇŘŠŤŽáéíóúýčďěňřšťž]/g, "");
    return letters.slice(0, 2).toUpperCase() || "?";
  }
  return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
};

export const shareLogoUrl = (isin) => {
  if (!isin) return "";
  const token = process.env.VUE_APP_LOGO_DEV_TOKEN;
  if (token) {
    return `https://img.logo.dev/isin/${encodeURIComponent(isin)}?token=${encodeURIComponent(token)}&format=png&size=128`;
  }
  const domain = ISIN_DOMAIN[isin];
  if (!domain) return "";
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=128`;
};
